// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Licensed under the Apache License, Version 2.0 (https://www.apache.org/licenses/LICENSE-2.0).
export const FIELD_TYPES = [
    'string',
    'number',
    'integer',
    'boolean',
    'string[]',
    'number[]',
    'integer[]',
    'boolean[]',
];
/** Types that can have a list of allowed values (BDA accepts `enum` only on strings and string list items). */
export const CHOICE_TYPES = ['string', 'string[]'];
export const ROLES = ['BlueprintAuthor', 'BlueprintViewer', 'Admin'];
/** Roles that may use the author features (blueprints, runs, previews, sets, packages); Admins can do everything authors can. */
export const AUTHOR_ROLES = ['BlueprintAuthor', 'Admin'];
export const TERMINAL_RUN_STATUSES = ['SUCCEEDED', 'FAILED'];
/** Every segment of a result; single-segment (and older) results yield one segment built from the top level. */
export function resultSegments(result) {
    if (result.segments && result.segments.length > 0)
        return result.segments;
    return [
        {
            index: 0,
            pageStart: 1,
            pageEnd: Math.max(1, result.pages),
            status: 'MATCH',
            fields: result.fields,
            tables: result.tables,
        },
    ];
}
/** "Pages 1–20" label for a segment. */
export const segmentLabel = (s) => s.pageStart === s.pageEnd ? `Page ${s.pageStart}` : `Pages ${s.pageStart}–${s.pageEnd}`;
export const AUDIT_ACTIONS = [
    'SIGN_IN',
    'BLUEPRINT_CREATE',
    'BLUEPRINT_UPDATE',
    'BLUEPRINT_PUBLISH',
    'BLUEPRINT_ARCHIVE',
    'BLUEPRINT_UNARCHIVE',
    'BLUEPRINT_DUPLICATE',
    'RUN_START',
    'RUN_SUCCEEDED',
    'RUN_FAILED',
    'RUN_PREVIEW',
    'RUN_PREVIEW_DENIED',
    'PACKAGE_CREATE',
    'SHARE_ADD',
    'SHARE_REVOKE',
    'ADMIN_VIEW_TIMELINE',
    'ADMIN_VIEW_BLUEPRINT',
    'ADMIN_DOWNLOAD_SCHEMA',
    'ADMIN_EXPORT_CSV',
    'SET_CREATE',
    'SET_UPDATE',
    'SET_PUBLISH',
    'SET_ARCHIVE',
    'SET_DUPLICATE',
    'SET_DENIED',
];
/** Upload limits (requirement 5.2). */
export const MAX_UPLOAD_BYTES = 52_428_800;
/** BDA's per-document page limit with the splitter on (asynchronous API; requirement 5.2). */
export const MAX_DOCUMENT_PAGES = 3000;
/** Documents up to this many pages run with the blueprint inline; longer ones go through a splitter project. */
export const INLINE_MAX_PAGES = 20;
/** The upload limits as shown next to every file picker (requirement 5.2). */
export const UPLOAD_LIMITS_TEXT = 'PDF, PNG, JPEG, or TIFF up to 50 MB and 3,000 pages.';
export const TOO_LARGE_MESSAGE = 'Files must be 50 MB or smaller (and have at most 3,000 pages).';
export const tooManyPagesMessage = (pages) => `This document has ${pages.toLocaleString('en-US')} pages. Documents can have at most 3,000 pages (and 50 MB).`;
/** A Sample_Packet over `suggestSet.maxPages` (blueprint-sets Req 9.2); the browser and the API show the same text. */
export const tooManyPacketPagesMessage = (pages, maxPages) => `This document has ${pages.toLocaleString('en-US')} pages. A sample packet can have at most ${maxPages.toLocaleString('en-US')} pages.`;
export const ALLOWED_CONTENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'];
export const MAX_PACKAGE_SAMPLES = 5;
//# sourceMappingURL=types.js.map